import { useEffect, useState } from 'react'

interface KeyboardState {
  pressedKey: string | null
  ctrlKey: boolean
  shiftKey: boolean
  altKey: boolean
  metaKey: boolean
}

export const useKeyboard = (): KeyboardState => {
  const [keyboardState, setKeyboardState] = useState<KeyboardState>({
    pressedKey: null,
    ctrlKey: false,
    shiftKey: false,
    altKey: false,
    metaKey: false
  })

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      setKeyboardState({
        pressedKey: event.key,
        ctrlKey: event.ctrlKey,
        shiftKey: event.shiftKey,
        altKey: event.altKey,
        metaKey: event.metaKey
      })
    }

    const handleKeyUp = (event: KeyboardEvent) => {
      setKeyboardState(prevState => {
        const isTargetKeyReleased = prevState.pressedKey === event.key

        return {
          pressedKey: isTargetKeyReleased ? null : prevState.pressedKey,
          ctrlKey: event.ctrlKey,
          shiftKey: event.shiftKey,
          altKey: event.altKey,
          metaKey: event.metaKey
        }
      })
    }

    window.addEventListener('keydown', handleKeyDown)
    window.addEventListener('keyup', handleKeyUp)

    return () => {
      window.removeEventListener('keydown', handleKeyDown)
      window.removeEventListener('keyup', handleKeyUp)
    }
  }, [])

  return keyboardState
}
